<template>
  <v-card>
    <v-tabs
      v-model="tab"
      background-color="blue-grey lighten-5"
    >
      <v-tab key="ad_unit">Placement Groups</v-tab>
      <v-tab key="ad_placement">Placements</v-tab>
      <v-tab key="ad_refill">Energy Refill</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="mt-4">
      <v-tab-item key="ad_unit">
        <r-ad-unit-page/>
      </v-tab-item>
      <v-tab-item key="ad_placement">
        <r-ad-placement-page/>
      </v-tab-item>
      <v-tab-item key="ad_refill">
        <r-ad-refill-page/>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import RAdRefillPage from "@/modules/redactor/views/ad-settings/refill/r-ad-refill-page.vue";
import RAdUnitPage from "@/modules/redactor/views/ad-settings/unit/r-ad-unit-page.vue";
import RAdPlacementPage from "@/modules/redactor/views/ad-settings/placement/r-ad-placement-page.vue";

export default {
  name: "r-ad-settings-page",
  components: {RAdPlacementPage, RAdUnitPage, RAdRefillPage},
  data: () => ({
    tab: null
  })
}

</script>